export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "VALUE_UNKNOWN": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["'", _interpolate(_named("value")), "' does not exist"])},
        "NEW_VALUE_HINT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter a name"])},
        "ADD_VALUE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add value"])}
      }
    }
  })
}
